module.exports = __webpack_public_path__ + "img/3.12ec572c.jpg";